import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";

const TemporalChartsContent = ({data}) => {
    useEffect(() => {

        if (data?.day_analisys) {
            const labels = [];
            const values = [];

            data.day_analisys.forEach((element) => {
                labels.push(element.apprehension_day);
                values.push(element.qty);
            });

            GraphicUtils.lineChart('day-apprehension', [['Apreensões', ...values]], labels);
            if (labels.length > 0) ReportUtils.createExportableTable(labels, values, 'Apreensões por dia', null, ['Dia', 'Quantidade']);
        }

        if (data?.weekday_analisys) {
            const labels = [];
            const values = [];

            data?.weekday_analisys.forEach((element) => {
                labels.push(element.apprehension_day);
                values.push(element.qty);
            });

            GraphicUtils.barChart('dow-apprehension', values, labels);
            if (labels.length > 0) ReportUtils.createExportableTable(labels, values, 'Apreensões por dia da semana', null, ['Dia da semana', 'Quantidade']);
        }

        if (data?.month_analisys) {
            const labels = [];
            const values = [];

            data.month_analisys.forEach((element) => {
                labels.push(element.apprehension_day);
                values.push(element.qty);
            });

            GraphicUtils.lineChart('month-apprehension', [['Apreensões', ...values]], labels);
            if (labels.length > 0) ReportUtils.createExportableTable(labels, values, 'Apreensões por mês', null, ['Mês', 'Quantidade']);

        }

    }, [data]);

    return (
        <>
            <div id="temporal">

                <div className="report-divisor mb-6">
                    <span className="divisor-title"> ANÁLISE TEMPORAL </span>
                </div>

                <div className="chart-report">
                    <span className="chart-title">Apreensões por dia</span>
                    <div className="mt-3" id={'day-apprehension'}></div>
                </div>

                <div className="chart-divisor"/>

                <div className="chart-report">
                    <span className="chart-title">Apreensões por dia da semana</span>
                    <div className="mt-3" id={'dow-apprehension'}></div>
                </div>

                <div className="chart-divisor"/>

                <div className="chart-report">
                    <span className="chart-title">Apreensões por mês</span>
                    <div className="mt-3" id={'month-apprehension'}></div>
                </div>

            </div>
        </>
    );
};

export default TemporalChartsContent;